import { render, staticRenderFns } from "./courseCollect.vue?vue&type=template&id=f24ded1e"
import script from "./courseCollect.vue?vue&type=script&lang=js"
export * from "./courseCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports